import { ThunkResult } from "..";
import { apiGet } from "../../utils/api";
import * as actions from "./actions";
import { IBestLeague, IElementPriceChange, IMostValuableTeam } from "./types";

export const fetchBestClassicPrivateLeagues =
  (): ThunkResult<Promise<void>> => async (dispatch) => {
    try {
      await apiGet<IBestLeague[]>(
        `stats/best-classic-private-leagues/`,
        dispatch,
        actions.fetchBestClassicPrivateLeagues,
      );
    } catch (e) {
      return;
    }
  };

export const fetchMostValuableTeams =
  (): ThunkResult<Promise<void>> => async (dispatch) => {
    try {
      await apiGet<IMostValuableTeam[]>(
        `stats/most-valuable-teams/`,
        dispatch,
        actions.fetchMostValuableTeams,
      );
    } catch (e) {
      return;
    }
  };

export const fetchElementPriceChanges =
  (): ThunkResult<Promise<void>> => async (dispatch) => {
    try {
      await apiGet<IElementPriceChange[]>(
        `stats/price-changes/`,
        dispatch,
        actions.fetchElementPriceChanges,
      );
    } catch (e) {
      return;
    }
  };
